<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#D7D8FF" stroke="#7019FD" />
        <rect x="4.5" y="4.5" width="11" height="11" rx="5.5" fill="#7019FD" stroke="#7019FD" />
   </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 20,
    },
    width: {
        ...iconProps.width,
        default: 20,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 21 19",
    }
  },
}
</script>